import { Assets, Texture } from 'pixi.js';
import type { Sprite } from 'pixi.js';

function createTextureFromBase64(base64: string): Promise<void> {
  return new Promise<void>((resolve) => {
    const img = new Image();
    img.onload = (): void => {
      Assets.cache.set(base64, Texture.from(img));
      resolve();
    };
    img.src = base64;
  });
}

export async function insertAvatar(sprite: Sprite, url: string): Promise<void> {
  const { width, height } = sprite;

  if (!Assets.cache.has(url)) {
    try {
      if (url.startsWith('data:image/png')) {
        await createTextureFromBase64(url);
      } else {
        await Assets.load(url);
      }
    } catch (e) {
      return;
    }
  }

  if (sprite.destroyed) return;
  sprite.props({
    texture: url,
    width,
    height,
  });
}
